import { useState } from "react";

interface EditableFileNameProps {
  initialName: string;
  onSave: (newName: string) => Promise<void>;
}

export function EditableFileName({ initialName, onSave }: EditableFileNameProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(initialName);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (name.trim() === initialName.trim() || !name.trim()) {
      setIsEditing(false);
      setName(initialName);
      return;
    }

    setSaving(true);
    try {
      await onSave(name.trim());
      setIsEditing(false);
    } catch (err) {
      console.error("Erreur lors de la sauvegarde du nom:", err);
      // Toast pourrait être ajouté ici si nécessaire
      setName(initialName);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setName(initialName);
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <div className="flex items-center gap-2 flex-1">
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSave();
            if (e.key === "Escape") handleCancel();
          }}
          disabled={saving}
          autoFocus
          className="flex-1 px-2 py-1 text-sm border border-indigo-300 rounded focus:ring-2 focus:ring-indigo-500 focus:outline-none"
        />
        <button
          onClick={handleSave}
          disabled={saving}
          className="text-green-600 hover:text-green-800 disabled:opacity-50"
          title="Sauvegarder"
        >
          ✓
        </button>
        <button
          onClick={handleCancel}
          disabled={saving}
          className="text-red-600 hover:text-red-800 disabled:opacity-50"
          title="Annuler"
        >
          ✕
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 flex-1">
      <span className="flex-1 font-medium text-gray-900">{initialName}</span>
      <button
        onClick={() => setIsEditing(true)}
        className="text-gray-400 hover:text-indigo-600 transition-colors"
        title="Modifier le nom"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
        </svg>
      </button>
    </div>
  );
}

